var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"width":"100%","height":"100vh"},attrs:{"src":"https://icra.muraciet.az/main","frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }